// extracted by mini-css-extract-plugin
module.exports = {"modal":"CartsPageModal_modal__3Pjuq","radioContainer":"CartsPageModal_radioContainer__pS5km","buttonContainer":"CartsPageModal_buttonContainer__2KKr3"};